module.exports = __webpack_public_path__ + "videos/video-premium-benefit-profit.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/premium/video-premium-benefit-profit.mp4
// module id = 976
// module chunks = 1